import { useMemo } from 'react';
import { getStudentUserFullName } from 'helpers/app.helper';
import { getDisplayedAtRiskStudents, getIncompleteAssignmentCount } from './DisengagedStudentList.helper';
var DisengagedStudentRow = function (_a) {
    var name = _a.name, incompleteCount = _a.incompleteCount;
    return (<div className="c-cw-engagement-insight-card__list-item">
    <span className="c-cw-engagement-insight-card__list-item--name">{name}</span>
    <span>{"".concat(incompleteCount, " incomplete ").concat(incompleteCount === 1 ? 'assignment' : 'assignments')}</span>
  </div>);
};
var DisengagedStudentList = function (_a) {
    var students = _a.students;
    var displayStudents = useMemo(function () { return getDisplayedAtRiskStudents(students); }, [students]);
    if (displayStudents.length === 0) {
        return <div className="c-cw-engagement-insight-card__list">Nothing here yet. As students fall behind, this section will list your most disengaged students.</div>;
    }
    return (<div className="c-cw-engagement-insight-card__list">
      {displayStudents.map(function (student) { return (<DisengagedStudentRow key={student.userId} name={getStudentUserFullName(student)} incompleteCount={getIncompleteAssignmentCount(student)}/>); })}
    </div>);
};
export default DisengagedStudentList;
